import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a0e1e772ab6ae0014be2aea/vaultis/src/app/sign-up-login-screen/components/AuthScreen.tsx");
